import layouts from 'core/layouts';
import layoutsLux from 'core/layouts-lux';
import tabConfig from 'core/tabConfig';
import getSettingsRoutes from 'core/routes/settings';
import dashboardRoutes from 'core/routes/dashboards';
import getPrimaryRoutes from 'core/routes/primary';
import getBrowserOptions from 'core/browserOptions';
import getDatasourcesRoutes from 'core/routes/datasources';
import dbaRoutes from 'core/routes/dba';
import i18n from 'core/i18n';

const getConfig = () => {
  let configuration = {
    maintenance: {
      dates: [
        new Date(2016, 6, 23), // July 23, 2016
        new Date(2016, 6, 30), // July 30, 2016
      ],
    },
    // primary navigation tabs
    primaryTabs: [
      {
        routes: getPrimaryRoutes(),
      },
    ],
    routes: {
      'survey-management': {
        isAuthRequired: false,
        label: i18n.getString('siteNav.surveyManagement'),
        icon: 'editReport',
      },
      dba: dbaRoutes,
      login: {
        isAuthRequired: false,
        layout: 'authenticate',
        controller: 'user',
      },
      chart: {
        isAuthRequired: false,
        layout: 'chart',
        controller: 'user',
      },
      profile: {
        layout: 'user-profile',
        controller: 'hierarchy',
        permissions: 'portal_access',
      },
      dashboards: dashboardRoutes,
      settings: getSettingsRoutes(),
      error: {
        isAuthRequired: false,
        layout: 'server-error',
        controller: 'user',
        permissions: 'error',
      },
    },
    defaultLayout: 'server-error',
    defaultRoute: 'dashboards',
    layouts: layouts,
    layoutsLux: layoutsLux,
    tabs: tabConfig,
    browserOptions: getBrowserOptions(),
  };

  const datasourcesRoutes = getDatasourcesRoutes();
  if (datasourcesRoutes) {
    configuration.routes.datasources = datasourcesRoutes;
  }

  return configuration;
};

export default getConfig;
